import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile'
import { Card, ConfigProvider, Form, message, Pagination, Popover, Table, Input, Select, Button, Space, Popconfirm, Typography, Checkbox,Row, Col } from 'antd'
import { DeleteOutlined, EditOutlined, EyeInvisibleOutlined, EyeTwoTone, PlusOutlined, SwitcherOutlined, EyeOutlined } from "@ant-design/icons";
import { data } from '../../test';
import { QuestionCircleOutlined } from '@ant-design/icons';
import './GenericEmailCopy.css'
import axios from 'axios';
import { Editor } from '@tinymce/tinymce-react';
import { Config } from '../Common/Config';
import { customDropdown } from '../Common/CommonFunction';
const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;


const GenericEmailCopy = () => {
    const editorRef = useRef(null);
    const [form] = Form.useForm();
    const [clinicDataSetInUpdate, setclinicDataSet] = useState({})
    const [allClinicData, setallClinicData] = useState([])
    const [loader, setloader] = useState(false)
    const [showPriceBucket, setshowPriceBucket] = useState(null)
    const [allbucketData, setallbucketData] = useState([])
    const [CurrentPage, setCurrentPage] = useState(1)
    const [isClinicCreateEnable, setisClinicCreateEnable] = useState(false)
    const [isAddEmail, setisAddEmail] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    const [showAddButton, setshowAddButton] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [editTextArea, seteditTextArea] = useState(null)
    const [showEditorOnlyAdd, setshowEditorOnlyAdd] = useState(true)
    const [mode, setMode] = useState('edit') // 'view' or 'edit'
    const isViewMode = mode === 'view'
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            getAllGenericEmailData()
            hasFetched.current = true;
        }
    }, [CurrentPage])


    // useEffect(() => {
    //     getAllBucketsData()
    // }, [])
    const getAllGenericEmailData = async () => {
        setloader(true)
        try {
            // const response = await axios.get(`${Config.url}generic-email/page/${CurrentPage}`, {
            const response = await axios.get(`${Config.url}generic-email`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            setallClinicData(response?.data?.data)
            setloader(false)
            hasFetched.current = false;
        } catch (error) {
            console.log('error in get clinic data ::::', error)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
            setloader(false)
        }
    }
    const getAllBucketsData = async () => {
        setloader(true)
        try {
            const response = await axios.get(`${Config.url}clinic-bucket-pricing`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response?.data?.data) {
                let bucketDropDown = [], bucketObj = {}
                if (response?.data?.data && response?.data?.data?.data) {
                    response?.data?.data?.data.map(buc => {
                        bucketDropDown.push({
                            label: buc.bucket_name,
                            value: buc.id
                        })
                        bucketObj[buc.id] = buc.bucket_name
                    })
                    setallbucketData(bucketDropDown)
                    setshowPriceBucket(bucketObj)
                }

            } else {

            }

            setloader(false)
        } catch (error) {
            console.log('error in get clinic data ::::', error)
            setloader(false)
        }
    }
    const columns = [
        {
            title: 'Section',
            dataIndex: 'section_title',
            key: 'section_title',
            render: (_, record) => (
                <div
                    dangerouslySetInnerHTML={{ __html: record.section_title }}
                />
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (_, record) => (
                <div>
                    {record?.section_status == 1 ? 'Active' : 'Inactive'}
                </div>
            ),
        },
        {
            title: '',
            key: 'action',
            render: (_, record) => (
                <div style={{ textAlign: 'right', marginRight: 2 }} onClick={(e) => e.stopPropagation()}>
                    <Popover placement="left" trigger="click" content={() => popoverContent(record)}>
                        <button
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                fontWeight: 700, fontSize: 18, letterSpacing: 2,
                                color: '#008385', padding: '0 6px', lineHeight: 1,
                            }}
                        >···</button>
                    </Popover>
                </div>
            ),
        },
    ];

    const popoverContent = (record) => {
        return (
            <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
                <div
                    className="rule-action-item"
                    style={{ color: '#008385' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        setshowAddButton(false)
                        setisClinicCreateEnable(true)
                        setMode('view')
                        setloader(true)
                        form.setFieldsValue({ ...record })
                        setisAddEmail(false)
                        setclinicDataSet(record)
                        setloader(false)
                        setshowEditorOnlyAdd(false)
                        document.querySelector('.clinicCreate-form')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                >
                    <EyeOutlined style={{ fontSize: 15 }} /> View
                </div>
                <div
                    className="rule-action-item"
                    style={{ color: '#008385' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        setshowAddButton(false)
                        setisClinicCreateEnable(true)
                        setMode('edit')
                        setloader(true)
                        form.setFieldsValue({ ...record })
                        setisAddEmail(false)
                        setclinicDataSet(record)
                        setloader(false)
                        setshowEditorOnlyAdd(false)
                        document.querySelector('.clinicCreate-form')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                >
                    <EditOutlined style={{ fontSize: 15 }} /> Edit
                </div>
                <div className="rule-action-divider" />
                <Popconfirm
                    title="Update status"
                    description="Are you sure you want to update status?"
                    onConfirm={() => updateStatus(record)}
                    icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                    okButtonProps={{ className: 'confirmation-popup-ok-button' }}
                    cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
                    okText="Yes"
                    cancelText="No"
                >
                    <div className="rule-action-item" style={{ color: '#008385' }}>
                        <SwitcherOutlined style={{ fontSize: 15 }} />
                        {record && record.section_status == 1 ? 'Make Inactive' : 'Make Active'}
                    </div>
                </Popconfirm>
                <div className="rule-action-divider" />
                <Popconfirm
                    title="Delete"
                    description="Are you sure you want to delete?"
                    onConfirm={() => deleteUser(record)}
                    icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                    okButtonProps={{ className: 'confirmation-popup-ok-button' }}
                    cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
                    okText="Yes, Delete"
                    cancelText="Cancel"
                >
                    <div className="rule-action-item rule-action-item--delete">
                        <DeleteOutlined style={{ fontSize: 15 }} /> Delete
                    </div>
                </Popconfirm>
            </div>
        )
    };
    const updateStatus = async (record) => {
        if (!record?.id) {
            return
        }
        setloader(true)
        let url = `${Config.url}generic-email/${record.id}`
        try {
            const response = await axios.put(url, {
                "section_status": record.section_status == 1 ? 0 : 1
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            // console.log(' Successful:', response);

            messageApi.success({
                type: 'succes',
                content: 'Product status updated successfully',
            });
            setloader(false)
            getAllGenericEmailData(CurrentPage)
        } catch (error) {
            messageApi.error({
                type: 'error',
                content: 'Something Went wrong',
            });
            // console.log('update user:', error.response?.data || error.message);
            // throw error;
        }
        setloader(false)
    }
    const deleteUser = async (record) => {
        let url = `${Config.url}generic-email/${record.id}`
        try {
            const response = await axios.delete(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })

            messageApi.success({
                type: 'succes',
                content: 'Clinic deleted successfully',
            });
            getAllGenericEmailData()
        } catch (error) {
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message ? error.response?.data?.message || error.message : 'Something went Wrong',
            });
            // console.log('update :', error.response?.data?.message || error.message);
            // throw error;
        }
    }
    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a style={{ color: '#4A4A4A' }}>Previous</a>;
        }
        if (type === 'next') {
            return <a style={{ color: '#4A4A4A' }}>Next</a>;
        }
        return originalElement;
    };
    const onFinish = async (values, update = false) => {
        // console.log(':::::values::::', values)
        if (values?.section_title && typeof values?.section_title == 'object') {
            values.section_title = values?.section_title?.level?.content
        }
        values.sections_options.map(a => {
            if (a?.content && typeof a?.content == 'object') {
                a.content = a?.content.level?.content
            }
        })
        // console.log(':::::values: final:::', values)
        // return

        // return
        setIsSubmitting(true)
        try {

            if (!update) {
                let url = `${Config.url}generic-email`, rooms = []
                let payload = {
                    ...values,
                    section_status: 1
                }
                // console.log('payload :::', payload)
                // return
                const response = await axios.post(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                form.setFieldsValue({
                    "section_title": '',
                    "sections_options": [],
                    section_status: 1
                });
                setclinicDataSet({})
                setisAddEmail(false)
                getAllGenericEmailData()
                setisClinicCreateEnable(false)
                setshowAddButton(true)
                setIsSubmitting(false)
                messageApi.success({
                    type: 'succes',
                    content: 'Generic-email added successfully',
                });
            } else {
                if (!clinicDataSetInUpdate.id) {
                    setloader(false)
                    return
                }
                let url = `${Config.url}generic-email/${clinicDataSetInUpdate.id}`, rooms = []
                let payload = {
                    ...values,
                    section_status: values.section_status
                }
                // console.log('payload :::', payload)

                const response = await axios.put(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                form.setFieldsValue({
                    "section_title": '',
                    "sections_options": [],
                    section_status: ''
                })
                setclinicDataSet({})
                getAllGenericEmailData()
                setisClinicCreateEnable(false)
                setshowAddButton(true)
                setIsSubmitting(false)
                messageApi.success({
                    type: 'succes',
                    content: 'Generic-email updated successfully',
                });
            }

        } catch (error) {
            setloader(false)
            setIsSubmitting(false)
            console.log(':error:::', error)
            messageApi.error({
                type: 'succes',
                content: error.response?.data?.message || error.message || 'Something Went wrong',
            });
        }
    }
    const clearCancelForm = () => {
        setMode(null)
        setshowAddButton(true)
        form.setFieldsValue({
            "section_title": '',
            "sections_options": [],
            section_status: ''
        });
        setisAddEmail(false)
        setclinicDataSet({ sections_options: { content: "", insert_first: false, linkContain: false } })
        setisClinicCreateEnable(false)
    }
    const validateURL = (_, value) => {
        try {
            if (!value || new URL(value)) {
                return Promise.resolve();
            }
        } catch (_) {
            return Promise.reject("Please enter a valid URL");
        }
    };
    return (
        <App>
            {contextHolder}
            <div style={{ display: 'grid', justifyContent: 'center' }}>
                <div style={{ display: 'flex' }}>
                    {allClinicData && <div style={{ display: "flex", justifyContent: 'flex-start', alignItems: "center", marginBottom: "10px" }}>
                        <Title level={5} style={{ margin: 0, color: "#008385", fontSize: 20 }}>
                            Generic email booking confirmation copy <span style={{ color: "black", fontWeight: '400' }}>({allClinicData?.total ? allClinicData.total : '00'})</span>
                        </Title>
                    </div>}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Card
                        className='addClinic-table'
                        style={{ width: 950, margin: 0, padding: 0, borderRadius: 50, boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)" }}
                    >
                        <ConfigProvider
                            theme={{
                                components: {
                                    Table: {
                                        headerBg: "#008385",
                                        headerColor: "#ffffff",
                                    },
                                    Spin: {
                                        colorPrimary: "#008385", // Change this to your desired color
                                    },
                                },
                            }}
                        >


                            {allClinicData && <Table
                                loading={loader}
                                columns={columns}
                                dataSource={allClinicData?.data}
                                pagination={false}
                                onRow={(record) => ({
                                    onClick: () => {
                                        setMode('view');
                                        setshowAddButton(false);
                                        setisClinicCreateEnable(true);
                                        setshowEditorOnlyAdd(false);
                                        setisAddEmail(false);
                                        form.setFieldsValue(record);
                                        setclinicDataSet(record);
                                        document.querySelector(".clinicCreate-form")?.scrollIntoView({ behavior: "smooth" });
                                    }
                                })}
                                scroll={{
                                    x: 'auto',
                                    y: 330,
                                }}
                            // style={{ height: 367 }}
                            />}
                            {allClinicData && allClinicData?.total ? <Pagination
                                align="center"
                                defaultCurrent={1}
                                defaultPageSize={10}
                                total={allClinicData?.total}
                                style={{ marginTop: 10 }}
                                onChange={(val, filter) => {
                                    setCurrentPage(val)
                                }}
                                itemRender={itemRender}
                            /> : ''}
                        </ConfigProvider>
                    </Card>
                </div>
            </div>
            {showAddButton && <div className='clinicCreate-form button-add-left' style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
                <Button className='add-generic-btn' onClick={() => {
                    setMode('edit')
                    setisClinicCreateEnable(true)
                    setshowEditorOnlyAdd(true)
                    setisAddEmail(true)
                    form.setFieldsValue({
                        "section_title": '',
                        "sections_options": [{ content: "", insert_first: false, linkContain: false }]
                    })
                }}>
                    Add an option
                </Button>
            </div>}
            {isClinicCreateEnable && <div style={{ display: "flex", justifyContent: "center", gap: 20, padding: 20 }}>
                {clinicDataSetInUpdate && (loader == false) && <Card
                    className={mode === 'view' ? 'clinician-view-mode-card view-mode-card' : ''}
                    style={{ width: 795, padding: 20 }}
                    title={
                        mode === 'view' ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <div style={{
                                    width: 38, height: 38, borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #008385, #00a3a5)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    color: '#fff', fontWeight: 700, fontSize: 15, flexShrink: 0,
                                    boxShadow: '0 2px 6px rgba(0,131,133,0.30)',
                                }}>
                                    {(clinicDataSetInUpdate?.section_title || '?').replace(/<[^>]+>/g, '').trim().charAt(0).toUpperCase() || '?'}
                                </div>
                                <span style={{ fontWeight: 700, fontSize: 15, color: '#007a7c' }}>
                                    {clinicDataSetInUpdate?.section_title
                                        ? clinicDataSetInUpdate.section_title.replace(/<[^>]+>/g, '').trim() || 'Option'
                                        : 'Option'}
                                </span>
                            </div>
                        ) : <span style={{ textAlign: 'left', display: 'block' }}>Option 1 details</span>
                    }
                >
                    {clinicDataSetInUpdate && (loader == false) && (
                        <Form
                            form={form}
                            layout="vertical"
                            initialValues={clinicDataSetInUpdate ? clinicDataSetInUpdate : null}
                            onFinish={(values) => onFinish(values, clinicDataSetInUpdate && clinicDataSetInUpdate.id && Object.keys(clinicDataSetInUpdate)?.length ? true : false)}
                        >
                            <div style={{ display: 'flex', flexWrap: 'wrap' }} className='leftInputFields'>
                                <Form.Item label='Subject:' name="section_title" className='leftInputFields' style={{ flex: 1, marginRight: 10 }} rules={[{ required: mode !== 'view', message: "Subject is required." }]}>
                                    {mode === 'view' ? (
                                        <div dangerouslySetInnerHTML={{ __html: form.getFieldValue('section_title') }} />
                                    ) : (
                                        <Editor
                                            apiKey={Config.apiKey}
                                            onInit={(_evt, editor) => editorRef.current = editor}
                                            init={{
                                                height: 150,
                                                width: 704,
                                                marginTop: 50,
                                                menubar: false,
                                                plugins: [
                                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                ],
                                                toolbar: 'undo redo | blocks |  link | unlink' + 'undo redo | blocks ' +
                                                    'bold italic forecolor | alignleft aligncenter ' +
                                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                                    'removeformat  ' + 'link | unlink',
                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                                placeholder: 'Subject:',
                                            }}
                                            onEditorChange={(newContent) => {
                                                form.setFieldsValue({ section_title: newContent });
                                            }}
                                        />
                                    )}
                                </Form.Item>

                            </div>
                            <div style={{ position: "relative", marginBottom: 15 }}>

                                <Form.List
                                    name="sections_options"
                                    initialValue={[{ content: "", insert_first: false, linkContain: false }]}
                                >
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }, index) => {
                                                let sections = form.getFieldValue('sections_options') || [];
                                                if (sections && sections.length) {
                                                    sections.map(a => {
                                                        if (a?.content && typeof a?.content == 'object') {
                                                            a.content = a?.content.level?.content
                                                        }
                                                    })
                                                }
                                                const itemData = sections[index] || {};
                                                let isEdit = editTextArea === index && !showEditorOnlyAdd;
                                                if (isAddEmail) {
                                                    isEdit = true
                                                }
                                                if (mode === 'view') {
                                                    isEdit = false
                                                }

                                                return (
                                                    <div key={key} style={{ marginBottom: 24, position: 'relative' }}>
                                                        <span
                                                            className="inputbox-custom-placeholder"
                                                            style={{ display: "block", textAlign: "start" }}
                                                        >
                                                            Email Section {index + 1}:
                                                        </span>

                                                        <Form.Item
                                                            {...restField}
                                                            name={[name, "content"]}
                                                            key={`content-${key}`}
                                                            style={{ flex: 1 }}
                                                            rules={[{ required: mode !== 'view', message: "Content is required." }]}
                                                        >
                                                            {!isEdit ? (
                                                                <div
                                                                    className="emailCopy"
                                                                    dangerouslySetInnerHTML={{ __html: itemData.content }}
                                                                />
                                                            ) : (
                                                                <Editor
                                                                    apiKey={Config.apiKey}
                                                                    value={itemData.content || ''}
                                                                    onInit={(_evt, editor) => (editorRef.current = editor)}
                                                                    init={{
                                                                        height: 250,
                                                                        width: 704,
                                                                        menubar: false,
                                                                        plugins: [
                                                                            "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
                                                                            "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
                                                                            "insertdatetime", "media", "table", "code", "help", "wordcount"
                                                                        ],
                                                                        toolbar:
                                                                            "undo redo | blocks | link unlink | customDropdown | bold italic forecolor | " +
                                                                            "alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
                                                                        setup: (editor) => {
                                                                            customDropdown(editor, 'short-codes')
                                                                        },
                                                                        content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                                        placeholder: 'Email Section'
                                                                    }}
                                                                    onEditorChange={(newContent, editor) => {
                                                                        const updatedList = form.getFieldValue('sections_options')?.map((item, i) => {
                                                                            if (i === index) {
                                                                                return { ...item, content: newContent }
                                                                            } else {
                                                                                return item
                                                                            }

                                                                        });
                                                                        form.setFieldsValue({ sections_options: updatedList });
                                                                    }}
                                                                />
                                                            )}
                                                        </Form.Item>

                                                        {!isEdit && !showEditorOnlyAdd && mode !== 'view' && (
                                                            <EditOutlined
                                                                onClick={() => seteditTextArea(index)}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 30,
                                                                    right: 10,
                                                                    fontSize: 18,
                                                                    color: "#999",
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        )}

                                                        <div
                                                            style={{
                                                                // display: 'flex', 
                                                                // gap: '16px' 
                                                                display: "none"
                                                            }}>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "insert_first"]}
                                                                key={`insert_first-${key}`}
                                                                valuePropName="checked"
                                                            >
                                                                <Checkbox style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                                    Insert first?
                                                                </Checkbox>
                                                            </Form.Item>

                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "linkContain"]}
                                                                key={`linkContain-${key}`}
                                                                valuePropName="checked"
                                                            >
                                                                <Checkbox style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                                    Contains cancellation links?
                                                                </Checkbox>
                                                            </Form.Item>

                                                            {key > 0 && (
                                                                <Button
                                                                    type="text"
                                                                    icon={<DeleteOutlined />}
                                                                    onClick={() => remove(name)}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                            <Row gutter={16}>
                                                <Col span={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                            <Button
                                                disabled={mode === 'view'}
                                                style={{ width: '100%' }}
                                                type="default"
                                                onClick={() => add({ content: "", insert_first: false, linkContain: false })}
                                                // icon={<PlusOutlined />}
                                            >
                                                Add a section
                                            </Button>
                                            </Col>
                                                <Col span={12} >
                                            {clinicDataSetInUpdate && clinicDataSetInUpdate.id && Object.keys(clinicDataSetInUpdate)?.length ? (
                                                mode === 'view' ? (
                                                    <span>{form.getFieldValue('section_status') === '1' ? 'Active' : 'Inactive'}</span>
                                                ) : (
                                                    <Form.Item
                                                        name="section_status"
                                                        style={{ margin: 0, minWidth: 140 }}
                                                        rules={[{ required: true, message: "Status selection is required" }]}
                                                    >
                                                        <Select placeholder="Status" className="inputbox-custom-placeholder">
                                                            <Option value="1">Active</Option>
                                                            <Option value="0">Inactive</Option>
                                                        </Select>
                                                    </Form.Item>
                                                )
                                            ) : null}
                                            </Col>
                                            </Row>
                                        </>
                                    )}
                                </Form.List>

                            </div>
                            {/* {clinicDataSetInUpdate && clinicDataSetInUpdate.id && Object.keys(clinicDataSetInUpdate)?.length ? <Space.Compact style={{ width: "100%", marginTop: 10 }}>
                                <Form.Item name="section_status" style={{ flex: 1 }} rules={[{ required: true, message: "Status selection is required" }]}>
                                    <Select placeholder="Status" className="inputbox-custom-placeholder" >
                                        <Option value="1">Active</Option>
                                        <Option value="0">Inactive</Option>
                                    </Select>
                                </Form.Item>
                            </Space.Compact> : ''} */}
                            {mode === 'view' ? (
                                <div style={{ display: 'flex', gap: 12, marginTop: 16, paddingBottom: 4 }}>
                                    <Button
                                        onClick={clearCancelForm}
                                        style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}
                                    >Cancel</Button>
                                    <Button
                                        className="edit-btn-green"
                                        icon={<EditOutlined />}
                                        onClick={() => setMode('edit')}
                                        style={{ minWidth: 100 }}
                                    >Edit</Button>
                                </div>
                            ) : (
                                <>
                                    <Button type="primary" className="add-generic-btn" style={{ marginTop: 10, backgroundColor: "#008385", borderColor: '#008385', marginRight: '16px', width: 140 }} onClick={clearCancelForm}>
                                        Cancel
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={isSubmitting}
                                        disabled={isSubmitting}
                                        style={{ marginTop: 10, backgroundColor: isSubmitting ? '#80bebe' : '#008385', borderColor: isSubmitting ? '#80bebe' : '#008385', color: '#fff', width: 140 }}
                                    >
                                        {isSubmitting ? 'Saving...' : 'Save'}
                                    </Button>
                                </>
                            )}
                        </Form>
                    )}
                </Card>}
            </div>}
        </App>
    )
}

export default GenericEmailCopy



